export { default } from "./ModalCoupon-component";
